import React from 'react';
import cx from 'classnames';
import { Link, useHistory } from 'react-router-dom';

import { Tooltip } from '@trqk/components';
import { formatNumberCompact } from '@trqk/utils';

import { getWorkDetailPath } from '../../../../../../utils';
import { DataCardRow } from '../components';

const earningsColor = 'quarternary';

interface DetectionSummaryRowProps {
    index: number;
    summaryData: InsightDetectionSummaryData;
}

const titleClasses = 'font-medium truncate';

export const DetectionSummaryRow = ({
    index,
    summaryData,
}: DetectionSummaryRowProps): JSX.Element => {
    const {
        location: { search },
    } = useHistory();
    const { audio_id, detection_count, song_id, channel } = summaryData;

    let { title } = summaryData;
    let message = `${channel}: ${title}`;

    if (title === 'not_reported' || title === 'not reported') {
        if (channel === undefined || channel === '') {
            title = 'Unknown track';
            message = title;
        } else {
            title = '';
            message = channel;
        }
    }

    const trackDetailPath = getWorkDetailPath({
        audioDeleted: false,
        search,
        trqkSongId: song_id,
        trqkAudioId: audio_id,
    });

    return (
        <DataCardRow index={index}>
            <Tooltip message={message} position="bottom" background="light">
                <div
                    className={cx('grid', {
                        underline: trackDetailPath !== null,
                    })}
                    style={{
                        gridTemplateColumns: '55px auto',
                    }}
                >
                    {channel && (
                        <div className="truncate mr-1 font-semibold">
                            {channel}
                        </div>
                    )}
                    {trackDetailPath && (
                        <Link className={titleClasses} to={trackDetailPath}>
                            {title}
                        </Link>
                    )}
                    {!trackDetailPath && (
                        <div className={titleClasses}>{title}</div>
                    )}
                </div>
            </Tooltip>
            <span className={`ml-2 font-semibold text-${earningsColor}-500`}>
                {formatNumberCompact(detection_count)}
            </span>
        </DataCardRow>
    );
};
